module.exports = __webpack_public_path__ + "static/media/location-selection-demo.5a50b59c.gif";